import { cn } from "@/lib/utils";
import { ChevronRightIcon } from "lucide-react";
import { ReactNode } from "react";

type MenuButtonLinkProps = {
	label: string | ReactNode;
	icon?: ReactNode;
	menuLabelClassName?: string;
	fontWeight?: "bold" | "medium";
	rightElement?: ReactNode;
	iconColor?: "primary" | "gray";
	subText?: string;
};

const MenuButton = ({
	label,
	icon,
	menuLabelClassName,
	fontWeight = "bold",
	rightElement,
	iconColor = "primary",
	subText,
}: MenuButtonLinkProps) => {
	return (
		<div className="flex items-center justify-between min-h-16">
			<div className="flex items-center justify-center gap-4">
				{icon && (
					<div
						className={cn(
							"flex items-center justify-center w-12 h-12 rounded-full",
							iconColor === "primary"
								? "bg-primary-50 text-textDark"
								: "bg-muted text-muted-foreground",
						)}
					>
						{icon}
					</div>
				)}
				<div>
					<span
						className={cn(
							"text-base text-textDark",
							fontWeight === "bold" ? "font-bold" : "font-medium",
							menuLabelClassName,
						)}
					>
						{label}
					</span>
					{subText && <div className="text-sm  text-textLight">{subText}</div>}
				</div>
			</div>
			{rightElement || (
				<ChevronRightIcon className="w-8 text-muted-foreground" />
			)}
		</div>
	);
};

export default MenuButton;
